import * as React from 'react';
import { connect } from 'react-redux';
import { Connector } from './calendarsConnector';

import { CalendarTypesComponent } from './components/CalendarTypesComponent';
import { MarqueeComponent } from '../common/components/MarqueeComponent';
import { CalendarsMarqueeSidePanel } from './components/CalendarsMarqueeSidePanel';
import { TwoUpSection } from './components/TwoUpSection';

import './scss/calendars.scss';
import '@sfly/uig-button';

import { SavedProject, VisitOnDesktop } from '../common/components/CommonMobileSpecificComponents';
import PropTypes from 'prop-types';
import { CommonUtils } from '../common/util/CommonUtils';
import { StandaloneContentComponent } from './components/StandaloneContentComponent';

require('es6-promise').polyfill();

export class CalendarsApp extends React.Component {
    constructor(props) {
        super(props);
        this.connector = new Connector(props.dispatch);
        this.connector.fetchConfigDetails();
        this.commonUtils = new CommonUtils();
    }

    render() {
        const {
            marquee,
            twoUpSectionData,
            standaloneContents,
            calendarTypes,
            calendarTypesSectionHeadings,
            marqueeSidePanelData,
            promoWells,
            pricingDetails
        } = this.props;

        return(
            <React.Fragment>
                <div id="promoBannerTop" className="promo-banner-top" dangerouslySetInnerHTML={this.commonUtils.getDynamicContent(promoWells.promoBannerTop)} />
                <MarqueeComponent marqueeDetails={marquee} hideOnMobile={false}>
                    <CalendarsMarqueeSidePanel promoDetails={promoWells.promoBoxDetails} marqueeSidePanelDetails={marqueeSidePanelData} pricingDetails={pricingDetails} />
                </MarqueeComponent>
                <div id="promoBannerBottom" className="promo-banner-bottom" dangerouslySetInnerHTML={this.commonUtils.getDynamicContent(promoWells.promoBannerBottom)} />
                <SavedProject />
                <StandaloneContentComponent id="wall-calendars-mobile" standaloneContents={standaloneContents} className="hide-on-desktop" pricingDetails={pricingDetails} />
                <TwoUpSection twoUpSectionData={twoUpSectionData} pricingDetails={pricingDetails} />
                <div id="apcCalendars" />
                <CalendarTypesComponent calendarTypes={calendarTypes} calendarTypesSectionHeadings={calendarTypesSectionHeadings} pricingDetails={pricingDetails} />
                <div className="h-line hide-on-mobile" />
                <VisitOnDesktop />
            </React.Fragment>
        );

    }
}

function mapStateToProps({ calendars, common }) {
    return {
        marquee: common.marquee,
        twoUpSectionData: calendars.twoUpSectionData,
        standaloneContents: calendars.standaloneContents,
        calendarTypes: calendars.calendarTypes,
        marqueeSidePanelData: calendars.marqueeSidePanelData,
        promoWells: common.promoWells,
        calendarTypesSectionHeadings: calendars.calendarTypesSectionHeadings,
        pricingDetails: common.pricingDetails
    };
}

export default connect(mapStateToProps)(CalendarsApp);

CalendarsApp.propTypes = {
    dispatch: PropTypes.func,
    marquee: PropTypes.object,
    twoUpSectionData: PropTypes.array,
    standaloneContents: PropTypes.array,
    calendarTypes: PropTypes.array,
    marqueeSidePanelData: PropTypes.object,
    promoWells: PropTypes.object,
    calendarTypesSectionHeadings: PropTypes.object,
    pricingDetails: PropTypes.array
};

CalendarsApp.defaultProps = {
    dispatch: () => {},
    marquee: {},
    twoUpSectionData: [],
    standaloneContents: [],
    calendarTypes: [],
    marqueeSidePanelData: {},
    promoWells: {},
    calendarTypesSectionHeadings: {},
    pricingDetails: []
};
